export default class LanguageCodes {
  public static readonly ENGLISH = "en";
  public static readonly PORTUGUESE = "pt";
}
